<template>
<section class="singUp" style="position:relative;z-index: 5;">
        <v-container>
         <v-form :value='true' @submit.prevent="singUp()" ref="singUp">
          <div>
                <v-text-field :label="$t('formes.labels.name')" type="text" :rules="[rules.required, rules.counter]" hide-details="auto"
                :counter="20" prepend-icon="fa fa-user" dark class="font-weight-bold"
                required v-model="signUpData.name"  :validate-on-blur='true'
                ></v-text-field>
          </div>
          <div>
                <v-text-field :label="$t('formes.labels.email')" type="email" :rules="[rules.required, rules.counter,rules.email]" 
                :counter="20" prepend-icon="fa fa-envelope" class="font-weight-bold" 
                required v-model="signUpData.email" dark hide-details="auto" :validate-on-blur='true'
                :error-messages='$t(`formes.errors.${errorMessages.email.code}`)' :error="errorMessages.email.show"
                @keypress="resetEmailError()"
                ></v-text-field>
          </div>
          <div>
               <v-text-field :label="$t('formes.labels.password')" :type="showPassword ? 'text' : 'password'" :rules="[rules.required, rules.counter]" hide-details="auto"
                :counter="20" prepend-icon="fa fa-key" dark class="font-weight-bold"
                required v-model="signUpData.password" :validate-on-blur='true'
                :append-icon="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"
                @click:append="showPassword = !showPassword"
                :error-messages='$t(`formes.errors.${errorMessages.password.code}`)' :error="errorMessages.password.show"
                @keypress="resetPasswordError()"
                ></v-text-field>
          </div>
          <v-btn 
           color="red" class="mt-4 text-capitalize rounded-pill font-weight-black" 
           dark
           :loading="loadingBtn"
           :ripple="true"
           type="submit"
           ><v-icon left>fa-sign-in</v-icon>{{$t('loginOut.register')}}</v-btn>
           <v-btn color="yellow" dark class="text-lowercase darken-3 mt-4 font-weight-black" absolute 
         @click="GoTologin()"
         :right='!$vuetify.rtl'
        :left="$vuetify.rtl"
         >{{$t('loginOut.haveAcount')}} 
         <span class="ms-4">{{$t('loginOut.login')}}</span></v-btn>
         <hr class="mt-5 mb-1">
         <p class="white--text text-center text-lowercase font-weight-black mb-1 mt-2">{{$t('loginOut.or')}}</p>
         <div class="shocial-login text-center">
         <v-btn :ripple="true" x-small class="blue--text darken-5"  fab><v-icon >fa-facebook </v-icon></v-btn>
         <v-btn :ripple="true" x-small class="ml-7" fab><v-icon >fa-google </v-icon></v-btn>
         </div>
         </v-form>
</v-container>
</section>
</template>

<script>
import firebase from '@/firebase/index';
import {validateRules} from '@/mixins/index'

export default {
    name:'signUp',
    data() {
        return {
            signUpData:{
               name:'',
               email:'',
               password:''
            }
        }
    },
    mixins:[validateRules],
    methods:{
        GoTologin(){
          this.$store.state.login=true;
        },
        singUp(){
            this.loadingBtn=true;
            const auth=firebase.auth();
            if(this.$refs.singUp.validate()){
                auth.createUserWithEmailAndPassword(this.signUpData.email,this.signUpData.password)
                 .then((cred)=>{
                        cred.user.updateProfile({
                               displayName:this.signUpData.name,
                               photoURL:'user.png'
                          })
                          .then(()=>{
                            this.$store.state.User={
                                avatar:'user.png',
                                adress:'',
                                email:cred.user.email,
                                name:this.signUpData.name
                            };
                            localStorage.setItem('user',JSON.stringify(this.$store.state.User));
                            this.$refs.singUp.reset();
                            this.loadingBtn=false;
                            if (this.$route.query.redirecto) {
                                    this.$router.push(this.$route.query.redirecto);
                            }else{
                                    this.$router.push({path:'/'});
                            }
                            })
                          })
                    .catch(error=>{
                        switch (error.code) {
                         case 'auth/email-already-in-use':
                             this.errorMessages.email.code='emailAlreadyInUse';
                             this.errorMessages.email.show=true;
                             break;
                         case 'auth/invalid-email':
                             this.errorMessages.email.code='invalidEmail';
                             this.errorMessages.email.show=true;
                             break;
                         case 'auth/user-disabled':
                             this.errorMessages.password.code='userDisabled';
                             this.errorMessages.email.code='userDisabled';
                             this.errorMessages.password.show=true;
                             this.errorMessages.email.show=true;
                             break
                         default:
                            this.errorMessages.password.code=error.code;
                             this.errorMessages.email.code='unknownError';
                             this.errorMessages.password.show=true;
                             this.errorMessages.email.show=true;
                     }
                     this.loadingBtn=false;
                     this.signUpData.password=''
                    })
                      }
               }
    }
}
</script>
